/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiReviewStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    WITHDRAWN = 'WITHDRAWN'
}


export function instanceOfInternalApiReviewStatus(value: any): boolean {
    for (const key in InternalApiReviewStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiReviewStatus, key)) {
            if (InternalApiReviewStatus[key as keyof typeof InternalApiReviewStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiReviewStatusFromJSON(json: any): InternalApiReviewStatus {
    return InternalApiReviewStatusFromJSONTyped(json, false);
}

export function InternalApiReviewStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiReviewStatus {
    return json as InternalApiReviewStatus;
}

export function InternalApiReviewStatusToJSON(value?: InternalApiReviewStatus | null): any {
    return value as any;
}

export function InternalApiReviewStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiReviewStatus {
    return value as InternalApiReviewStatus;
}

